/* ==========================================================================
   Bold Grip Socks — popup state machine.
   Four touchpoints: welcome bar, welcome popup, cart-leave catch, sticky bar.
   All analytics events dispatched to GA4, Reddit, Meta, Microsoft UET, and a
   window.bmAnalytics array for any custom listener.
   ========================================================================== */
(function () {
  'use strict';

  var SHARE_BASE = 'https://boldgripsocks.com/?ref=';
  var SHARE_TITLE = 'BOLD Grip Socks';
  var SHARE_TEXT = 'joined the BOLD Grip Socks email list. thought you’d want in:';
  var myRefCode = ''; // this entrant's referral code: first 5 letters/digits of their email
  var POPUP_DELAY_MS = 8000;
  var SCROLL_TRIGGER_PCT = 50;
  var CART_LEAVE_DELAY_MS = 2000;
  var STICKY_BAR_DELAY_MS = 12000;
  var DISMISS_TTL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

  var $bar = document.querySelector('[data-bmp-bar]');
  var $pop = document.querySelector('[data-bmp-pop]');
  var $stickybar = document.querySelector('[data-bmp-stickybar]');
  if (!$pop) return;

  var $popForm = $pop.querySelector('#bmp-popup-form') || $pop.querySelector('form.bmp-pop__form') || $pop.querySelector('[data-bmp-form]');
  var $popEmail = $pop.querySelector('[data-bmp-email]');
  var $popFirstName = $pop.querySelector('[data-bmp-firstname]');
  var $popPhone = $pop.querySelector('[data-bmp-phone]');
  var $popPhoneRow = $pop.querySelector('[data-bmp-phone-row]');
  var $popAddPhone = $pop.querySelector('[data-bmp-addphone]');
  var $popCta = $pop.querySelector('[data-bmp-cta]');
  var $popError = $pop.querySelector('[data-bmp-error]');
  var $popSuccess = $pop.querySelector('[data-bmp-success]');
  var $popMain = $pop.querySelector('[data-bmp-main]');

  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, val) { try { localStorage.setItem(key, val); } catch (e) {} }
  function ssGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, val) { try { sessionStorage.setItem(key, val); } catch (e) {} }

  var subscribed = lsGet('bm_subscribed') === '1';
  var barDismissed = lsGet('bm_bar_dismissed') === '1';
  var popDismissedAt = parseInt(lsGet('bm_pop_dismissed_at') || '0', 10);
  var popDismissedRecently = popDismissedAt && (Date.now() - popDismissedAt) < DISMISS_TTL_MS;
  var stickyDismissed = lsGet('bm_sticky_dismissed') === '1';
  var visitCount = parseInt(lsGet('bm_visits') || '0', 10) + 1;
  lsSet('bm_visits', String(visitCount));

  var popShownThisSession = ssGet('bm_pop_shown') === '1';
  var popOpenedAt = 0; // for the fast-submit review tag
  var cartLeaveShownThisSession = ssGet('bm_cartleave_shown') === '1';

  /* ============ Referral helpers ============
     Code = first 5 letters/digits of the referrer's email + a 4-char
     fingerprint of the FULL email. The prefix keeps it readable for Maria;
     the fingerprint makes it unique + collision-safe at scale (two similar
     emails no longer clash) and DETERMINISTIC (same email → same code every
     time, so a returning entrant keeps one code). Stored on the referrer's
     own record as tag `refcode-XXXXXYYYY`; a friend who signs up via
     ?ref=XXXXXYYYY is tagged `ref-by-XXXXXYYYY`. Maria tallies by tag search. */
  function hashStr(s) {
    var h = 5381, i = s.length;
    while (i) { h = (h * 33) ^ s.charCodeAt(--i); }
    return (h >>> 0).toString(36).slice(0, 4);
  }
  function refCodeFromEmail(email) {
    var e = String(email || '').toLowerCase();
    return e.replace(/[^a-z0-9]/g, '').slice(0, 5) + hashStr(e);
  }
  function sanitizeCode(v) {
    return String(v || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 12);
  }
  function getParam(name) {
    var m = new RegExp('[?&]' + name + '=([^&#]+)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function shareUrl() {
    var code = myRefCode || lsGet('bm_ref_code') || '';
    return code ? (SHARE_BASE + encodeURIComponent(code)) : 'https://boldgripsocks.com/';
  }

  // Contest closed 2026-09-14: ?ref= links are no longer referrals; treat as a normal visit.
  var incomingRef = '';

  /* ============ Analytics dispatcher ============ */
  function fireAnalytics(eventName, eventData) {
    eventData = eventData || {};
    var payload = Object.assign({ source: 'bm_popup', ts: Date.now() }, eventData);

    if (typeof window.gtag === 'function') {
      try { window.gtag('event', eventName, payload); } catch (e) {}
    }
    if (typeof window.rdt === 'function') {
      try {
        var rdtEvent = eventName === 'sign_up' ? 'Lead' : 'Custom';
        window.rdt('track', rdtEvent, { customEventName: eventName });
      } catch (e) {}
    }
    if (typeof window.fbq === 'function') {
      try {
        var fbEvent = eventName === 'sign_up' ? 'Lead' : 'CustomEvent';
        if (fbEvent === 'Lead') window.fbq('track', 'Lead', payload);
        else window.fbq('trackCustom', eventName, payload);
      } catch (e) {}
    }
    if (window.uetq && typeof window.uetq.push === 'function') {
      try { window.uetq.push('event', eventName, payload); } catch (e) {}
    }
    if (typeof window.ttq !== 'undefined' && window.ttq.track) {
      try {
        if (eventName === 'sign_up') window.ttq.track('Subscribe', payload);
        else window.ttq.track(eventName, payload);
      } catch (e) {}
    }
    if (typeof window.pintrk === 'function') {
      try {
        if (eventName === 'sign_up') window.pintrk('track', 'lead', payload);
      } catch (e) {}
    }
    if (window.analytics && typeof window.analytics.publish === 'function') {
      try { window.analytics.publish('bm_' + eventName, payload); } catch (e) {}
    }

    window.bmAnalytics = window.bmAnalytics || [];
    window.bmAnalytics.push({ event: eventName, data: payload });

    try {
      window.dispatchEvent(new CustomEvent('bm:' + eventName, { detail: payload }));
    } catch (e) {}
  }

  /* ============ Welcome bar ============ */
  function showBar() {
    if (!$bar || subscribed || barDismissed) return;
    $bar.hidden = false;
    requestAnimationFrame(function () { $bar.classList.add('is-open'); });
    fireAnalytics('popup_bar_shown', { touchpoint: 'welcome_bar' });

    var $close = $bar.querySelector('[data-bmp-bar-close]');
    if ($close) {
      $close.addEventListener('click', function () {
        $bar.classList.remove('is-open');
        setTimeout(function () { $bar.hidden = true; }, 400);
        lsSet('bm_bar_dismissed', '1');
        fireAnalytics('popup_bar_dismissed', { touchpoint: 'welcome_bar' });
      });
    }
  }

  /* ============ Welcome popup (slide-up) ============ */
  function openPopup(touchpoint) {
    if ($pop.classList.contains('is-open')) return;
    if (subscribed) return;
    $pop.hidden = false;
    requestAnimationFrame(function () { $pop.classList.add('is-open'); });
    ssSet('bm_pop_shown', '1');
    popShownThisSession = true;
    popOpenedAt = Date.now();
    fireAnalytics('popup_shown', { touchpoint: touchpoint || 'welcome' });
  }

  function closePopup(reason) {
    if (!$pop.classList.contains('is-open')) return;
    $pop.classList.remove('is-open');
    setTimeout(function () { $pop.hidden = true; }, 450);
    if (reason !== 'submit') {
      lsSet('bm_pop_dismissed_at', String(Date.now()));
      fireAnalytics('popup_dismissed', { reason: reason || 'close' });
    }
  }

  function showSuccess() {
    if (!$popMain || !$popSuccess) return;
    $popMain.style.display = 'none';
    $popSuccess.classList.add('is-shown');
    // stays open until the user dismisses it — code copies on X too
  }

  function successShowing() {
    return !!($popSuccess && $popSuccess.classList.contains('is-shown'));
  }

  /* ============ Share for bonus entries + toast ============ */
  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {}
  }

  function copyShareLink(via) {
    var url = shareUrl();
    var done = function () {
      showToast('Link copied');
      fireAnalytics('popup_share', { via: via || 'copy', method: 'clipboard' });
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () {
          legacyCopy(url);
          done();
        });
        return;
      }
    } catch (e) {}
    legacyCopy(url);
    done();
  }

  function shareInvite(via) {
    // Native share sheet on mobile; clipboard fallback everywhere else.
    if (navigator.share) {
      navigator.share({ title: SHARE_TITLE, text: SHARE_TEXT, url: shareUrl() })
        .then(function () { fireAnalytics('popup_share', { via: via || 'button', method: 'native' }); })
        .catch(function () { /* user cancelled — no toast, no error */ });
      return;
    }
    copyShareLink(via);
  }

  // Named one-tap channels (research: Gen Z converts in private DMs/texts).
  function shareMessage() { return SHARE_TEXT + ' ' + shareUrl(); }
  function smsHref(encodedBody) {
    // iOS reads sms:&body= ; Android reads sms:?body= (both per RFC 5724, diverged).
    var ios = /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
    return (ios ? 'sms:&body=' : 'sms:?body=') + encodedBody;
  }
  function shareVia(channel) {
    if (channel === 'copy') { copyShareLink('quickshare_copy'); return; }
    var msg = encodeURIComponent(shareMessage());
    var target = channel === 'sms' ? smsHref(msg) : ('https://wa.me/?text=' + msg);
    // fire before navigating so it's always recorded
    fireAnalytics('popup_share', { via: 'quickshare_' + channel, method: 'deeplink', target: target });
    if (channel === 'whatsapp') { window.open(target, '_blank', 'noopener'); }
    else { window.location.href = target; }
  }

  function showToast(msg) {
    var $t = document.querySelector('[data-bmp-toast]');
    if (!$t) {
      $t = document.createElement('div');
      $t.className = 'bmp-toast';
      $t.setAttribute('data-bmp-toast', '');
      $t.setAttribute('role', 'status');
      document.body.appendChild($t);
    }
    $t.textContent = msg;
    $t.classList.add('is-shown');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { $t.classList.remove('is-shown'); }, 2200);
  }

  function setError(msg) {
    if (!$popError) return;
    $popError.textContent = msg;
    $popError.classList.add('is-shown');
    if ($popEmail) $popEmail.classList.add('bmp-pop__field--error');
  }

  function clearError() {
    if (!$popError) return;
    $popError.classList.remove('is-shown');
    if ($popEmail) $popEmail.classList.remove('bmp-pop__field--error');
  }

  function isValidEmail(v) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(String(v || '').trim());
  }
  // Throwaway/disposable domains — the usual vehicle for giveaway/referral farming.
  // Client-side only (Shopify's captcha already blocks scripted bots); this trims
  // the human junk that DOES solve the challenge with a burner inbox.
  var DISPOSABLE_DOMAINS = {
    'mailinator.com':1,'guerrillamail.com':1,'guerrillamail.info':1,'sharklasers.com':1,
    'yopmail.com':1,'10minutemail.com':1,'temp-mail.org':1,'tempmail.com':1,'tempmailo.com':1,
    'throwawaymail.com':1,'trashmail.com':1,'getnada.com':1,'nada.email':1,'dispostable.com':1,
    'maildrop.cc':1,'mailnesia.com':1,'fakeinbox.com':1,'mohmal.com':1,'emailondeck.com':1,
    'moakt.com':1,'mytemp.email':1,'tempr.email':1,'burnermail.io':1,'inboxbear.com':1,
    'spam4.me':1,'grr.la':1,'einrot.com':1,'cuvox.de':1,'dayrep.com':1,'jourrapide.com':1
  };
  function isDisposableEmail(v) {
    var at = String(v || '').toLowerCase().lastIndexOf('@');
    if (at < 0) return false;
    return DISPOSABLE_DOMAINS[String(v).toLowerCase().slice(at + 1)] === 1;
  }

  if ($popAddPhone && $popPhoneRow) {
    $popAddPhone.addEventListener('click', function () {
      $popPhoneRow.classList.add('is-open');
      $popAddPhone.classList.add('is-open');
      fireAnalytics('popup_phone_revealed');
    });
  }

  /* ============ Submission ============
     AJAX-first, native fallback. The form is rendered with {% form 'customer' %}
     so the native fallback stays compatible with Shopify's captcha challenge
     flow. Happy path: background fetch to /contact — success (redirect carrying
     customer_posted=true) shows the success panel inline with NO navigation.
     If Shopify demands a challenge (redirect to /challenge) or anything else
     fails, fall back to a native same-window submit so the visitor can solve
     the challenge page and return via ?customer_posted=true (handled in boot).
     NEVER show success unless Shopify confirmed the signup. */
  if ($popForm) {
    $popForm.addEventListener('submit', function (e) {
      clearError();
      var email = ($popEmail && $popEmail.value || '').trim();
      var phone = ($popPhone && $popPhone.value || '').trim();
      if (!isValidEmail(email)) {
        e.preventDefault();
        setError('Please enter a valid email.');
        fireAnalytics('popup_error', { reason: 'invalid_email' });
        return;
      }
      if (isDisposableEmail(email)) {
        e.preventDefault();
        setError('Please use a permanent email so we can reach you if you win.');
        fireAnalytics('popup_error', { reason: 'disposable_email' });
        return;
      }
      // Honeypot: a filled hidden field = bot. Pretend success, post nothing.
      var $hp = $popForm.querySelector('input[name="bmp_hp"]');
      if ($hp && $hp.value) {
        e.preventDefault();
        fireAnalytics('popup_bot_honeypot', {});
        lsSet('bm_subscribed', '1');
        subscribed = true;
        showSuccess();
        return;
      }
      if ($hp) $hp.disabled = true; // never post the honeypot itself

      // Blank optional fields must not be posted (Shopify rejects malformed phone).
      if ($popPhone && !phone) $popPhone.disabled = true;
      if ($popFirstName && !($popFirstName.value || '').trim()) $popFirstName.disabled = true;
      $popCta.disabled = true;
      $popCta.textContent = 'Sending...';
      fireAnalytics('popup_submit', { has_phone: phone ? 'true' : 'false' });

      // Contest closed 2026-09-14: no referral/entry tags. The form's hidden
      // contact[tags] input (popup-welcome,newsletter) is submitted as-is.

      e.preventDefault();
      var fd = new FormData($popForm);
      fetch($popForm.getAttribute('action') || '/contact', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        redirect: 'follow'
      })
        .then(function (r) {
          if (r.redirected && /customer_posted=true/.test(r.url)) return true;
          throw new Error('not confirmed: ' + r.status + ' ' + r.url);
        })
        .then(function () {
          fireAnalytics('sign_up', { method: 'popup_newsletter', via: 'ajax' });
          lsSet('bm_subscribed', '1');
          subscribed = true;
          showSuccess();
        })
        .catch(function () {
          // Challenge required or network issue — native same-window submit
          // (bypasses this handler; Shopify's challenge page takes over).
          $popForm.submit();
        });
    });
  }

  /* ============ Welcome popup triggers ============ */
  function maybeTriggerWelcomePopup() {
    if (subscribed || popShownThisSession || popDismissedRecently) return;

    var scrollTriggered = false;
    // Referred friends see the invite fast (they arrived on purpose).
    var delay = incomingRef ? 2500 : POPUP_DELAY_MS;
    var timer = setTimeout(function () {
      if (!popShownThisSession) openPopup(incomingRef ? 'referral_landing' : 'welcome_timer');
    }, delay);

    function onScroll() {
      if (scrollTriggered || popShownThisSession) return;
      var doc = document.documentElement;
      var pct = (window.scrollY + window.innerHeight) / doc.scrollHeight * 100;
      if (pct >= SCROLL_TRIGGER_PCT) {
        scrollTriggered = true;
        clearTimeout(timer);
        openPopup('welcome_scroll');
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ============ Cart-leave catch ============ */
  function maybeAttachCartLeave() {
    if (subscribed || cartLeaveShownThisSession) return;

    function checkCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return cart && cart.item_count > 0; })
        .catch(function () { return false; });
    }

    window.addEventListener('popstate', function () {
      if (cartLeaveShownThisSession) return;
      ssSet('bm_cartleave_shown', '1');
      cartLeaveShownThisSession = true;
      checkCart().then(function (hasItems) {
        if (!hasItems) return;
        setTimeout(function () {
          var $title = $pop.querySelector('[data-bmp-title]');
          var $sub = $pop.querySelector('[data-bmp-sub]');
          if ($title) $title.innerHTML = 'Before you go —';
          if ($sub) $sub.innerHTML = "Join the list and you're entered to win a year of BOLD. Two draws only, August 1 and September 1.";
          openPopup('cart_leave');
        }, CART_LEAVE_DELAY_MS);
      });
    });
  }

  /* ============ Sticky bar (returning visitors) ============ */
  function maybeShowSticky() {
    if (!$stickybar || subscribed || stickyDismissed) return;
    if (visitCount < 2) return;
    if (popShownThisSession) return;

    setTimeout(function () {
      if ($pop.classList.contains('is-open')) return;
      $stickybar.hidden = false;
      requestAnimationFrame(function () { $stickybar.classList.add('is-open'); });
      fireAnalytics('popup_stickybar_shown', { touchpoint: 'return_sticky', visit_count: visitCount });

      var $close = $stickybar.querySelector('[data-bmp-stickybar-close]');
      if ($close) {
        $close.addEventListener('click', function () {
          $stickybar.classList.remove('is-open');
          setTimeout(function () { $stickybar.hidden = true; }, 400);
          lsSet('bm_sticky_dismissed', '1');
          fireAnalytics('popup_stickybar_dismissed');
        });
      }
    }, STICKY_BAR_DELAY_MS);
  }

  /* ============ Popup close + share bindings ============ */
  if ($pop) {
    var $close = $pop.querySelector('[data-bmp-close]');
    if ($close) {
      $close.addEventListener('click', function () { closePopup('close_x'); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && $pop.classList.contains('is-open')) closePopup('escape');
    });
    var $shareBtn = $pop.querySelector('[data-bmp-share-btn]');
    if ($shareBtn) {
      $shareBtn.addEventListener('click', function () { shareInvite('success_button'); });
    }
    var $qs = $pop.querySelectorAll('[data-bmp-qs]');
    for (var i = 0; i < $qs.length; i++) {
      (function (el) {
        el.addEventListener('click', function () { shareVia(el.getAttribute('data-bmp-qs')); });
      })($qs[i]);
    }
  }

  /* ============ Sticky bar → open popup ============ */
  if ($stickybar) {
    var $stickyOpen = $stickybar.querySelector('[data-bmp-sticky-open]');
    if ($stickyOpen) {
      $stickyOpen.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup('sticky_bar');
      });
    }
  }

  /* ============ Persistent "Refer a friend" pill ============
     For people who've already entered (subscribed): re-opens the share panel
     so they can grab their personal invite link anytime, without emailing us. */
  function openSharePanel(via) {
    if (!$pop) return;
    if ($popMain) $popMain.style.display = 'none';
    if ($popSuccess) $popSuccess.classList.add('is-shown');
    $pop.hidden = false;
    requestAnimationFrame(function () { $pop.classList.add('is-open'); });
    fireAnalytics('refer_panel_opened', { via: via || 'pill' });
  }

  function maybeShowReferPill() {
    var $refer = document.querySelector('[data-bmp-refer]');
    if (!$refer || !subscribed) return;               // only after they've entered
    if (ssGet('bm_refer_dismissed') === '1') return;

    var $open = $refer.querySelector('[data-bmp-refer-open]');
    var $x = $refer.querySelector('[data-bmp-refer-close]');
    if ($open) $open.addEventListener('click', function () { openSharePanel('pill'); });
    if ($x) $x.addEventListener('click', function () {
      $refer.classList.remove('is-open');
      setTimeout(function () { $refer.hidden = true; }, 300);
      ssSet('bm_refer_dismissed', '1');
    });

    setTimeout(function () {
      $refer.hidden = false;
      requestAnimationFrame(function () { $refer.classList.add('is-open'); });
      fireAnalytics('refer_pill_shown', {});
    }, 1500);
  }

  /* ============ Boot ============ */
  function boot() {
    // Returning from a native form submit (CAPTCHA fallback path):
    // Shopify redirects back with ?customer_posted=true on success.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      fireAnalytics('sign_up', { method: 'popup_newsletter', via: 'native_form' });
      openPopup('customer_posted_return');
      showSuccess();
      lsSet('bm_subscribed', '1');
      subscribed = true;
      return;
    }
    showBar();
    maybeTriggerWelcomePopup();
    maybeAttachCartLeave();
    maybeShowSticky();
    maybeShowReferPill();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();